import React from 'react';

import CustomerNotificationComponent from './customerNotificationComponent';
import MentorNotificationComponent from './mentorNotificationComponent';
import utilsService from '../../../services/utilsService';

const NotificationComponentRender = ({
  showAcceptBtnSpinner,
  showCloseIcon,
  showRejectBtnSpinner,
  acceptBtnTxt,
  closeBtnTxt,
  rejectBtnTxt,
  notificationInfoTxt,
  notificationInfoTxtComponent,
  notificationTxt,
  notificationType,
  acceptBtnFunc,
  closeBtnFunc,
  rejectBtnFunc,
}) => {
  const isMentor = !utilsService.getIsClient();

  return isMentor ? (
    <MentorNotificationComponent
      showAcceptBtnSpinner={showAcceptBtnSpinner}
      showRejectBtnSpinner={showRejectBtnSpinner}
      acceptBtnTxt={acceptBtnTxt}
      closeBtnTxt={closeBtnTxt}
      rejectBtnTxt={rejectBtnTxt}
      notificationInfoTxt={notificationInfoTxt}
      notificationInfoTxtComponent={notificationInfoTxtComponent}
      notificationTxt={notificationTxt}
      notificationType={notificationType}
      acceptBtnFunc={acceptBtnFunc}
      closeBtnFunc={closeBtnFunc}
      rejectBtnFunc={rejectBtnFunc}
    />
  ) : (
    <CustomerNotificationComponent
      showCloseIcon={showCloseIcon}
      acceptBtnTxt={acceptBtnTxt}
      closeBtnTxt={closeBtnTxt}
      rejectBtnTxt={rejectBtnTxt}
      notificationTxt={notificationTxt}
      notificationType={notificationType}
      acceptBtnFunc={acceptBtnFunc}
      closeBtnFunc={closeBtnFunc}
      rejectBtnFunc={rejectBtnFunc}
    />
  );
};

export default NotificationComponentRender;
